import styled from "styled-components";

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 230px;
  border-radius: 15px;
  background: url(${({ image }) => image});
  background-size: cover;
  cursor: pointer;

  svg {
    z-index: 1;
  }

  &:hover {
    &:after {
      background: rgba(0, 0, 0, 0.15) !important;
    }
  }

  &:after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 15px;
    background: rgba(0, 0, 0, 0.12);
  }
`;

export const Wrapper = styled.div`
  position: relative;
  border-radius: 15px;
`;

export const ImagePreview = styled.div`
  border-radius: 15px;
  position: relative;

  .buttons {
    visibility: hidden;
  }

  svg {
    z-index: 1;
  }

  &:hover {
    .buttons {
      visibility: visible;
    }
  }
`;

export const Image = styled.img`
  position: relative;
  user-select: none;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  row-gap: 12px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
`;

export const Divider = styled.div`
  opacity: 0.5;
  background: ${({ theme }) => theme.border.black15};
  width: 100%;
  height: 1px;
`;

export const CompleteReposition = styled.div`
  position: absolute;
  right: 0;
  top: -35px;
`;

export const FlexAlign = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const Text = styled.div`
  color: ${({ theme }) => theme.text.text};
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 20px auto;
  align-items: flex-start;
  column-gap: 4px;
  margin-top: 7px;
`;
